import { InterestCalculator } from "./InterestCalculator";
import "./index.css";

export function App() {
  return (
    <div className="container mx-auto p-4 md:p-8 max-w-4xl">
      <p className="text-sm text-muted-foreground text-center mb-6">
        Η εφαρμογή δημιουργήθηκε από τον δικηγόρο{" "}
        <a
          href="https://mertzanis.gr"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-foreground transition-colors"
        >
          Γιάννη Μερτζάνη
        </a>{" "}
        και απευθύνεται αποκλειστικά σε δικηγόρους.
      </p>
      <InterestCalculator />
      <footer className="mt-8 border-t pt-4 text-center text-lg text-muted-foreground">
        <a
          href="https://mysolon.gr"
          target="_blank"
          rel="noopener noreferrer"
          className="underline underline-offset-4 hover:text-foreground transition-colors"
        >
          mysolon.gr
        </a>
      </footer>
    </div>
  );
}

export default App;
